<template>
  <section>
    <a class="anchor" id="update"></a>
    <div class="parent">
        <b-carousel :indicator="false" class="left">
            <b-carousel-item v-for="(carousel, i) in carousels" :key="i" >
                    <div class="image hero-body has-text-centered">
                        <img class="member" :src="require('../assets/carousel/'+carousel.name+'.jpg')">
                    </div>
            </b-carousel-item>           
        </b-carousel>
        <div class="right">
            <h2 class="title">{{$t('updates')}}</h2>
            <ul class="ul updates">
                <li v-for="(update,i) in updates.slice().reverse()" v-bind:key="i"> <b-tag type="is-info">{{update.date}}</b-tag> {{update.info}}</li>
            </ul>
        </div>
    </div>
  </section>
</template>

<script>
import db from '@/db/index'
export default {
    name: 'Update',
    data() {
        return {
            carousels: [
                { name: '2019プール掃除'}, 
                { name: '2019プール掃除 2'},
                { name: '2019フットサル'},
                { name: '2019四校戦'},
                { name: '2019全国公'},
                { name: '四校戦 1'},
                { name: '四校戦 2'},
                { name: '四校戦 3'},
                { name: '四校戦 4'}
            ],
            updates: []
        }
    },
    created() {
        var self = this;
        db.getDatabase().ref("updates").once('value').then(function(snap){
            self.updates = snap.val();
        });
    },
}
</script>

<style scoped>
.parent {
    display: flex;
}
.left {
    flex: 2;
}
.right {
    flex: 1;
}
.updates {
    height:440px; 
    overflow-y:scroll
}
section {
    padding: 50px 10% 0 10%;
}
@media screen and (max-width: 800px) {
    .parent {
        flex-direction: column-reverse;
    }
}
</style>